import React from 'react';
import { useError } from '../ErrorContext';
import ErrorModal from './ErrorModal';

export default function GlobalErrorModal() {
  const { error, clearError } = useError();

  return (
    // error?.statusCode !== 404 &&
    <ErrorModal
      error={error}
      onClose={clearError}
    />
  );
}
